import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import type { TaskAction, TaskActionArgs } from '../types';
import { useOverviewChartDrilldownAction } from './use-overview-chart-drilldown-action';
import { useOverviewInsightsAction } from './use-overview-insights-action';
import { useProAssignUserRolesAction } from './use-pro-assign-user-roles-action';
import { useProFollowUpTasksAction } from './use-pro-follow-up-tasks-action';
import { useProReviewConversationAnalysisAction } from './use-pro-review-conversation-analysis-action';
import { useProViewCallInsightsAction } from './use-pro-view-call-insights-action';
import { useProViewPatientContextAction } from './use-pro-view-patient-context-action';

export function useProTaskActions(args: TaskActionArgs): Partial<Record<OnboardingProTask, TaskAction>> {
  const overviewInsights = useOverviewInsightsAction(args);
  const overviewChartDrilldown = useOverviewChartDrilldownAction(args);
  const viewCallInsights = useProViewCallInsightsAction(args);
  const reviewConversationAnalysis = useProReviewConversationAnalysisAction(args);
  const followUpTasks = useProFollowUpTasksAction(args);
  const viewPatientContext = useProViewPatientContextAction(args);
  const assignUserRoles = useProAssignUserRolesAction(args);

  return {
    [OnboardingProTask.PRO_TASK_OVERVIEW_INSIGHTS]: overviewInsights,
    [OnboardingProTask.PRO_TASK_OVERVIEW_CHART_DRILLDOWN]: overviewChartDrilldown,
    [OnboardingProTask.PRO_TASK_VIEW_CALL_INSIGHTS]: viewCallInsights,
    [OnboardingProTask.PRO_TASK_REVIEW_CONVERSATION_ANALYSIS]: reviewConversationAnalysis,
    [OnboardingProTask.PRO_TASK_FOLLOW_UP_TASKS]: followUpTasks,
    [OnboardingProTask.PRO_TASK_VIEW_PATIENT_CONTEXT]: viewPatientContext,
    [OnboardingProTask.PRO_TASK_ASSIGN_USER_ROLES]: assignUserRoles,
  };
}
